import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=6a20b4ee"
import script from "./MenuButton.vue?vue&type=script&lang=ts"
export * from "./MenuButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports